import { render, staticRenderFns } from "./projective-question-guide.vue?vue&type=template&id=ed9028f2"
import script from "./projective-question-guide.vue?vue&type=script&lang=js"
export * from "./projective-question-guide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports